/**
 * ============================================================================
 * DizyPro ERP
 * Module : Service CRM
 * Feature: Installed Products
 *
 * File:
 * src/modules/service_crm/installed_products/constants/engineMaster.js
 *
 * Description:
 * Engine related master data used by Installed Product Management.
 *
 * Responsibilities:
 * - Emission Norms
 * - Engine Models
 * - KVA Ratings
 * - Dependency helper methods
 *
 * NOTE:
 * These are frontend static masters.
 * Later they will be replaced by Master APIs.
 * ============================================================================
 */

export const ENGINE_MAKES = [
    { value: "", label: "Select" },
    { value: "KOEL", label: "KOEL" },
    { value: "NA", label: "NA" }
];

/* ============================================================================
 * ENGINE MASTER
 * ========================================================================== */

export const ENGINE_MASTER = {

    "CPCB-I": {

        models: {

            "2R1040": [
                "15 KVA",
                "20 KVA"
            ],

            "3R1040": [
                "25 KVA",
                "30 KVA"
            ],

            "4K1080TA1": [
                "100 KVA",
                "125.4 KVA"
            ],

            "4R1040": [
                "35 KVA",
                "40 KVA",
                "45 KVA"
            ],

            "4R1040T": [
                "62.5 KVA"
            ],

            "4R1040TA": [
                "82.5 KVA"
            ],

            "6K1080TA": [
                "160 KVA"
            ],

            "6R1080TA": [
                "125.6 KVA"
            ],

            "6R1080TA G1": [
                "140 KVA"
            ],

            "6SL 1500TA G2": [
                "180 KVA"
            ],

            "6SL 1500TA SR2": [
                "200 KVA"
            ],

            "6SL 8800TA": [
                "250 KVA"
            ],

            "DV10": [
                "500 KVA"
            ],

            "DV12": [
                "600 KVA"
            ],

            "DV12ETA": [
                "750 KVA"
            ],

            "DV12SR1": [
                "625 KVA"
            ],

            "DV16ETA": [
                "1010 KVA"
            ],

            "DV8SR1": [
                "320 KVA"
            ],

            "DV8SR2": [
                "380 KVA"
            ],

            "DV8TA G3": [
                "400 KVA"
            ],

            "HA294 G1": [
                "15 KVA"
            ]

        }

    },

    "CPCB-II": {

        models: {

            "12K4300-E1": [
                "1250 KVA"
            ],

            "12K4300-E2": [
                "1500 KVA"
            ],

            "DV16 ETA G4": [
                "1250 KVA"
            ],

            "DV16ETA G3": [
                "1010 KVA"
            ],

            "DV2300ETA": [
                "1250 KVA"
            ]

        }

    },
        "CPCB-IV": {

        models: {

            "2GK550NA 4Sr1": [
                "10 KVA"
            ],

            "3GK550ETC 4Sr1": [
                "25 KVA"
            ],

            "3GK550TC 4Sr2": [
                "15 KVA"
            ],

            "3GK550TC Sr1": [
                "20 KVA"
            ],

            "3R1190ENA 4G1": [
                "30 KVA",
                "35 KVA"
            ],

            "3R1190ETA 4G1": [
                "40 KVA",
                "45 KVA"
            ],

            "3R550ETA 4G1": [
                "25 KVA"
            ],

            "3R550NA-4G1": [
                "10 KVA"
            ],

            "3R550TA 4G1": [
                "20 KVA"
            ],

            "3R550TC 4G1": [
                "15 KVA"
            ],

            "4R1190ETA 4G1": [
                "82.5 KVA"
            ],

            "4R810ETA 4G1": [
                "58.5 KVA"
            ],

            "6K1080ETA 4G3": [
                "250 KVA"
            ],

            "CC 519": [
                "7.5 KVA"
            ],

            "DV10ETA 4G2": [
                "625 KVA"
            ],

            "DV12ETA 4G2": [
                "750 KVA"
            ],

            "DV8ETA 4G2": [
                "400 KVA"
            ],

            "DV8ETA 4G3": [
                "500 KVA"
            ],

            "EA10NA-4G1": [
                "7.5 KVA"
            ],

            "HA294NA 4G1": [
                "10 KVA",
                "12.5 KVA",
                "15 KVA"
            ]

        }

    },

    "NG CPCB-IV": {

        models: {

            "3R1040NG1": [
                "30 KVA"
            ],

            "6R1080 NG1": [
                "58.5 KVA"
            ],

            "DV8TA NG1": [
                "250 KVA"
            ],

            "HA294NG1": [
                "15 KVA"
            ],

            "SL90TA NG1": [
                "125 KVA"
            ]

        }

    },
        "OPTI CPCB-II": {

        models: {

            "12K4300-E1": [
                "2500 KVA (2x1250)"
            ],

            "12K4300-E2": [
                "3000 KVA (2x1500)"
            ],

            "DV16 ETA G3": [
                "2020 KVA (2x1010)"
            ]

        }

    },

    "OPTI CPCB-IV": {

        models: {

            "4K1080 ETA 4G1": [
                "250 KVA (2x125)"
            ],

            "4R810ETA 4G1": [
                "117 KVA (2x58.5)"
            ],

            "6K1080 ETA4G3": [
                "1000 KVA (4x250)"
            ],

            "6K1080ETA 4G2": [
                "400 KVA (2x200)"
            ],

            "6SL90ETA 4G2": [
                "1000 KVA (4x250)"
            ],

            "6SL90ETA 4G3": [
                "500 KVA (2x250)",
                "640 KVA (2x320)"
            ],

            "DV10ETA 4G2": [
                "1250 KVA (2x625)"
            ],

            "DV12ETA 4G2": [
                "1500 KVA (2x750)"
            ],

            "DV8ETA 4G3": [
                "1000 KVA (2x500)"
            ]

        }

    },

    "NA": {

        models: {

            "NA": [
                "NA"
            ]

        }

    }

};



/* ============================================================================
 * HELPER METHODS
 * ========================================================================== */

/**
 * Returns all available Emission Norms.
 */
export const getEmissionNorms = () => {

    return [
        { value: "", label: "Select" },
        ...Object.keys(ENGINE_MASTER).map(norm => ({
            value: norm,
            label: norm
        }))
    ];

};
/**
 * Returns engine makes for selected emission norm.
 */
export const getEngineMakes = (emissionNorm) => {

    if (!emissionNorm || !ENGINE_MASTER[emissionNorm]) {
        return [];
    }

    return [
        { value: "", label: "Select" },
        ...Object.keys(ENGINE_MASTER[emissionNorm].models).map(make => ({
            value: make,
            label: make
        }))
    ];

};
/**
 * Returns engine models for selected emission norm and make.
 */
export const getEngineModels = (emissionNorm) => {

    if (!emissionNorm || !ENGINE_MASTER[emissionNorm]) {
        return [];
    }

    return [
        { value: "", label: "Select" },

        ...Object.keys(
            ENGINE_MASTER[emissionNorm].models
        ).map(model => ({

            value: model,
            label: model

        })),

        { value: "NA", label: "NA" }

    ];

};
/**
 * Returns available KVA ratings.
 */
export const getKvaRatings = (
    emissionNorm,
    engineModel
) => {

    if (
        !emissionNorm ||
        !engineModel ||
        !ENGINE_MASTER[emissionNorm]
    ) {
        return [
            { value: "", label: "Select" }
        ];
    }

    const kvaRatings =
        ENGINE_MASTER[emissionNorm]
            ?.models?.[engineModel] || [];

    return [

        { value: "", label: "Select" },

        ...kvaRatings.map(kva => ({
            value: kva,
            label: kva
        })),

        { value: "NA", label: "NA" }

    ];

};
